<template>
  <div class="order">
    <div class="serch-wrap">
      <el-form label-position="left" :inline="true" :model="orderForm" class="demo-form-inline">
        <el-form-item label="主订单号">
          <el-input @keyup.enter.native="searchOrderList" v-model="orderForm.main_number" placeholder="主订单号"></el-input>
        </el-form-item>
        <el-form-item label="子订单号">
          <el-input @keyup.enter.native="searchOrderList" v-model="orderForm.order_number"
            placeholder="子订单号"></el-input>
        </el-form-item>
        <el-form-item label="编号" label-width="40px">
          <el-input v-model="orderForm.serialNumber"></el-input>
        </el-form-item>
        <!-- 主单状态 -->
        <el-form-item label="主单状态">
          <el-select v-model="orderForm.mainOrderStatus" clearable placeholder="请选择">
            <el-option v-for="item in mainOrderOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 物流状态（直发|工厂）2022-10-14新增 -->
        <el-form-item label="物流状态" v-if="statusActive === 4 && isZhifaOrFactory">
          <el-select v-model="orderForm.box_status" clearable placeholder="请选择">
            <el-option v-for="item in Object.keys(logStatusOptions)" :key="item" :label="logStatusOptions[item]"
              :value="item">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 同步状态 -->
        <el-form-item label="同步状态" v-if="syncStatusFlag">
          <el-select v-model="orderForm.syncStatus" clearable placeholder="请选择">
            <el-option v-for="item in syncOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="推送日期">
          <el-col :span="11">
            <el-date-picker type="datetime" placeholder="开始日期" v-model="orderForm.start_created_at"
              style="width: 100%;"></el-date-picker>
          </el-col>
          <el-col class="line" :span="2">-</el-col>
          <el-col :span="11">
            <el-date-picker type="datetime" placeholder="结束日期" v-model="orderForm.end_created_at"
              style="width: 100%;"></el-date-picker>
          </el-col>
        </el-form-item>
        <el-form-item label="物流联系电话" label-width="85px" v-show="statusActive === 4 || statusActive === 3">
          <el-input v-model="orderForm.courier_mobile"></el-input>
        </el-form-item>
        <el-form-item label="报备状态" label-width="60px">
          <el-select v-model="orderForm.shipping_status" placeholder="选择报备状态" clearable multiple>
            <el-option v-for="item in Object.keys(shipStatusOptions)" :key="item" :label="shipStatusOptions[item]"
              :value="item" />
          </el-select>
        </el-form-item>

        <div class="drop-down-wrap">
          <transition name="el-fade-in-linear">
            <el-button v-if="!dropStatus" type="text" icon="iconfont icon-xiangxiashuangjiantou"
              style="background:#fff;border:none;color:#666;font-size:24px;padding:0;" @click="dropHandler"></el-button>
            <el-button v-if="dropStatus" type="text" icon="iconfont icon-xiangshangshuangjiantou"
              style="background:#fff;border:none;color:#666;font-size:24px;padding:0;" @click="dropHandler"></el-button>
          </transition>
        </div>
        <el-collapse-transition>
          <div v-show="dropStatus">
            <el-form-item label="要求发货日">
              <el-col :span="11">
                <el-date-picker type="date" placeholder="开始日期" v-model="orderForm.start_out_ware_day"
                  style="width: 100%;"></el-date-picker>
              </el-col>
              <el-col class="line" :span="2">-</el-col>
              <el-col :span="11">
                <el-date-picker type="date" placeholder="结束日期" v-model="orderForm.end_out_ware_day"
                  style="width: 100%;"></el-date-picker>
              </el-col>
            </el-form-item>

            <el-form-item label="快递单号">
              <el-input v-model="orderForm.courierNumber"></el-input>
            </el-form-item>
          </div>
        </el-collapse-transition>
        <el-form-item>
          <el-button type="primary" @click="searchOrderList" size="small">查询</el-button>
          <!-- <el-button size="small" type="primary" @click="exportOrder">导出</el-button> -->
        </el-form-item>
      </el-form>
    </div>
    <div class="tableTitle">
      <span>查询结果：</span>
      <div class="tableStatus">
        <div>
          <div class="status" @click="getTableStatus(2)" :class="{ active: statusActive === 2 }">
            <p>备货中</p>
          </div>
          <div class="status" @click="getTableStatus(3)" :class="{ active: statusActive === 3 }">
            <p>已备货</p>
          </div>
          <div class="status" @click="getTableStatus(4)" :class="{ active: statusActive === 4 }">
            <p>已出库</p>
          </div>
          <div class="status" @click="getTableStatus(5)" :class="{ active: statusActive === 5 }">
            <p>失效</p>
          </div>
        </div>
        <div class="btns">
          <el-dropdown trigger="click" size="medium" placement="bottom" class="batchbtn" style="margin-left:15px;"
            @command="handleCommand" v-show="statusActive === 4 || statusActive === 3">
            <el-button type="primary" size="small">
              录入物流运单
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="b">录入全部</el-dropdown-item>
              <el-dropdown-item command="a">录入勾选</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button size="small" type="primary" @click="acceptGoods" v-show="statusActive === 1">接单</el-button>
          <el-button size="small" type="primary" v-show="statusActive === 2" @click="printStockList"
            class="blue">每日备货清单</el-button>

          <el-button size="small" type="primary" @click="autoPareDoneHandler"
            v-show="statusActive === 2">备货完成</el-button>
          <el-button size="small" type="primary" v-show="statusActive === 4" @click="completeGoods">订单打包</el-button>
          <el-button size="small" type="primary" @click="factoryOutGoods('dialogCancel')"
            v-show="statusActive === 3">出库</el-button>

          <el-button size="small" type="primary" @click="cancelGoods" v-show="showCancelGoods">取消备货</el-button>
          <el-button size="small" type="primary" @click="exportGoodsListHandler"
            v-show="statusActive === 3">导出货物清单</el-button>
          <el-button size="small" type="primary" @click="prinPurchaseHandler" v-show="statusActive === 3"
            v-if="isZhifaOrFactory">打印采购订单</el-button>
        </div>
      </div>
    </div>
    <order-table ref="orderTable" v-loading="loadOrderTable" @getDetailTable="getDetailTable" @getTrackNo="getTrackNo"
      @getBoxData="getBoxData" @updateOrder="getOrderList" @getSelectOrderData="getSelectOrderData"
      @acceptGoodsOk="acceptGoodsOk" @editOrder="editOrderHandler" @getTransportDetail="getTransportDetail"
      @getDetailAsyncStatus="getDetailAsyncStatus" :orderTableData="orderTableData"
      :statusActive="statusActive"></order-table>
    <order-print-table :orderTableData="orderTableData"></order-print-table>
    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
      :page-sizes="[10, 50, 100, 200]" :page-size.sync="pagesize" layout="total, sizes, prev, pager, next, jumper"
      :total="totalCount"></el-pagination>
    <el-tabs type="card" v-model="activeName">
      <el-tab-pane label="商品信息" name="goods_info">
        <order-detail-table @updateOrder="getOrderList"
          :orderDetailTableData="orderDetailTableData"></order-detail-table>
      </el-tab-pane>
      <el-tab-pane label="物流轨迹" name="log_track" v-if="statusActive === 4 && isZhifaOrFactory">
        <orderTrack :order_id="current_row_id" :main_number="current_row_main_number" order_type="1" />
      </el-tab-pane>
    </el-tabs>
    <order-dialog ref="orderDialog" :boxData="boxData"></order-dialog>
    <cancel-pare-dialog @cancelOrder="cancelOrder" ref="cancelPareDialog"></cancel-pare-dialog>
    <delivery-sheet ref="deliverySheet" :id="selectOrderDataId" :ids="selectOrderData" v-if="showdeliverySheet"
      v-show="false"></delivery-sheet>
    <order-cancel-dialog v-if="cancelOrderDialog" :dialog="cancelOrderDialog" :table="cancelDialogTable"
      @cancel="cancelDialogHandler" @confirm="cancelDialogConfirmHandler"></order-cancel-dialog>
    <transport-detail-dialog v-if="showTransportDetailDialog" :dialog="showTransportDetailDialog"
      :row="TransportDetailDialogRow" @cancel="() => (showTransportDetailDialog = false)"></transport-detail-dialog>
    <el-dialog :visible.sync="printDialogVisible" :append-to-body="true" center width="500px">
      <span slot="title" style="color:#fff;">确认</span>
      <p>
        确认打印<span class="red-color-text">{{ selectOrderData.length }}</span>个订单，共<span class="red-color-text">{{
          printBoxNumTotal }}</span>个打包箱数？
      </p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="printDialogVisible = false" size="mini">取 消</el-button>
        <el-button type="primary" @click="print(true)" size="mini">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="notice" :append-to-body="true" top="25vh" center width="580px">
      <span slot="title" style="color:#fff;font-size:16px;">关于调整店铺管理系统箱码打印方式的通知</span>
      <p style="font-size:16px;">
        店铺管理系统的箱码打印方式调整，变更为浏览器打印。打印操作说明详见
        <a @click="goNotice" class="notice">【公告中心】-【打印指导】。</a>
      </p>
      <p style="font-size:16px;">调整生效时间：2019年9月5日20:00点。</p>
      <p style="text-align:right;font-weight:600;">锐锢商城</p>
      <p style="text-align:right;font-weight:600;">2019年9月5日</p>
    </el-dialog>
    <el-dialog :visible.sync="outGoodsDialog" :append-to-body="true" top="25vh" center width="580px">
      <span slot="title" style="color:#fff;font-size:16px;">出库确认</span>
      <p>请确认是否出库</p>
      <p style="color:red;font-weight:bold;">一旦出库，则订单无法再更改状态</p>
      <div slot="footer" class="dialog-footer">
        <el-button @click="outGoodsDialog = false" size="mini">取 消</el-button>
        <el-button type="primary" @click="factoryOutGoods('sureOut')" size="mini">确 定</el-button>
      </div>
    </el-dialog>
    <boxcode ref="boxcode" v-show="false"></boxcode>
    <!-- 2021.06.01 同步信息弹窗 -->
    <el-dialog :visible.sync="orderSyncDialogVisible" :append-to-body="true" title="对接详情" width="580px">
      <p>
        <span>批次号：</span><span>{{ orderSyncInfo.main_number }}</span>
      </p>
      <p>
        <span>同步时间：</span><span>{{ orderSyncInfo.async_create_time }}</span>
      </p>
    </el-dialog>
  </div>
</template>
<script>
import { changeDateString, getOdStatusList } from "@/utils/utils";
import {
  listBox,
  getListWrongDetail,
  getOrderDetail,
  printLogisticsSheet,
  getWrongOrder,
  bigorderOutWare,
  exporOrdertData,
  autoPareDone,
  cancelOrderData,
  // getPurchaseList,
  batchPrintBoxCode,
  getFactoryOrderList,
  getBoxStatus, //物流状态枚举
  getNewList, //订单列表（直发|工厂）
  getShipStatusEnum
} from "@/models/orderModel";
// import {
//   courierStatusQuery
// } from '@/models/ts'
import orderTable from "@/components/bigorder/order-table.vue";
import orderPrintTable from "@/components/bigorder/order-print-table.vue";
import cancelPareDialog from "@/components/bigorder/cancelPare-dialog.vue";
import orderDetailTable from "@/components/bigorder/order-detail-table.vue";
import orderDialog from "@/components/bigorder/order-status-dialog.vue";
import TransportDetailDialog from "@/components/bigorder/TransportDetailDialog.vue";
import OrderCancelDialog from "@/components/bigorder/OrderCancelDialog.vue";
import boxcode from "@/components/print/boxcode";
import deliverySheet from "./delivery-sheet.vue";
import orderTrack from "@/components/order/order-track.vue"; //物流轨迹
// import { eventBus } from '@/event-bus'
// import { error } from 'util'
// import { truncate } from 'fs'
import moment from "moment";
const tsStatusList = [
  { text: "新建", value: 1 },
  { text: "准备揽件", value: 2 },
  { text: "已取货", value: 3 },
  { text: "配送中", value: 4 },
  { text: "配送完成", value: 5 },
  { text: "非系统通知订单", value: 6 },
  { text: "取消", value: -1 }
];
export default {
  components: {
    orderTable,
    orderPrintTable,
    orderDialog,
    orderDetailTable,
    cancelPareDialog,
    deliverySheet,
    OrderCancelDialog,
    TransportDetailDialog,
    boxcode,
    orderTrack
  },
  data() {
    return {
      tsStatusList,
      dropStatus: false,
      isZhifaOrFactory: false,
      isZhifa: false,
      isFactory: false,
      isPingTai: false,
      notice: false,
      showdeliverySheet: false, // 导出货物清单 不可见改元素
      orderForm: {
        order_number: "",
        start_created_at: "",
        end_created_at: "",
        start_out_ware_day: "",
        end_out_ware_day: "",
        instatus: "2",
        tsStatus: "",
        is_ts: null,
        is_boxnum: null,
        courier_mobile: "",
        // 主单状态
        mainOrderStatus: "",
        // 同步状态
        syncStatus: "",
        box_status: "", //物流状态
        shipping_status: [] //报备状态
      },
      pagesize: 10,
      currentPage: 1,
      totalCount: 0,
      orderTableData: [],
      orderDetailTableData: [],
      // od_statusList: [],
      loadOrderTable: true,
      boxData: [],
      selectOrderDataId: "",
      selectOrderData: [],
      statusActive: 2,
      selectOrderNo: "",
      cancelOrderDialog: false, // 订单取消弹窗
      cancelDialogTable: {}, // 订单取消弹窗数据
      showTransportDetailDialog: false,
      orderSyncDialogVisible: false, // 订单同步状态弹窗
      orderSyncInfo: {}, // 订单同步状态信息
      TransportDetailDialogRow: {},
      printDialogVisible: false,
      printBoxNumTotal: 0,
      boxcodeList: [],
      showInputTs: false,
      canInputTs: false,
      outGoodsDialog: false, // 出库确认
      // 同步状态
      syncOptions: [],
      // 主单状态
      mainOrderOptions: [],
      logStatusOptions: {}, //物流状态
      // 同步状态是否显示
      syncStatusFlag: null,
      activeName: "goods_info", //默认展示商品信息
      current_row_id: undefined, //当前选中行id
      current_row_main_number: undefined, //当前选中行主单号
      shipStatusOptions: {} //报备状态
    };
  },
  computed: {
    showCancelGoods() {
      return this.statusActive === 3;
    }
  },
  created() {
    let pageIndex = sessionStorage.getItem("bigorder_tab_index_pageIndex");
    if (pageIndex) {
      this.currentPage = Number(pageIndex);
    }
    if (localStorage.getItem("shop_type") === "2") {
      this.canInputTs = true;
      this.isFactory = true;
      this.isZhifaOrFactory = true;
    }
    if (localStorage.getItem("shop_type") === "1") {
      this.isZhifa = true;
      this.isZhifaOrFactory = true;
    }
    if (localStorage.getItem("shop_type") === "0") {
      this.isPingTai = true;
    }
    // 同步状态是否显示
    let syncStatusFlag = localStorage.getItem("syncStatus");
    if (syncStatusFlag !== "0") {
      this.syncStatusFlag = true;
    } else {
      this.syncStatusFlag = false;
    }
    this.initSelectData();
  },
  mounted() {
    let index = sessionStorage.getItem("bigorder_tab_index");
    if (index) {
      this.getTableStatus(Number(index), true);
    }
    let pageIndex = sessionStorage.getItem("bigorder_tab_index_pageIndex");
    if (pageIndex) {
      this.currentPage = Number(pageIndex);
    }
    this.getOrderList(true);

    if (localStorage.getItem("show_notice") === "1") {
      this.notice = false;
    } else {
      if (moment().format("YYYY-MM-DD") < "2019-09-11") {
        this.notice = true;
        localStorage.setItem("show_notice", "1");
      }
    }
  },
  methods: {
    moment,
    dropHandler() {
      this.dropStatus = !this.dropStatus;
    },
    goNotice() {
      this.$router.push({
        path: "/notice/printNotice"
      });
    },
    // 初始筛选项 下拉数据
    initSelectData() {
      this.mainOrderOptions = getOdStatusList().mo_statusList;
      this.syncOptions = getOdStatusList().syncStatuslist;
      this.getTrackStatus();
      this.getShipStatus();
    },

    // 获取物流状态枚举
    async getTrackStatus() {
      const res = await getBoxStatus();
      this.logStatusOptions = res || {};
    },
    // 获取报备状态枚举
    async getShipStatus() {
      const res = await getShipStatusEnum();
      this.shipStatusOptions = res || {};
    },

    // 导出 邮箱中查收
    async exportOrder() {
      let params = {
        main_number: this.orderForm.main_number,
        order_number: this.orderForm.order_number,
        instatus: this.orderForm.instatus
      };
      if (this.orderForm.start_created_at) {
        params.start_created_at = changeDateString(
          this.orderForm.start_created_at
        );
      }
      if (this.orderForm.end_created_at) {
        params.end_created_at = changeDateString(this.orderForm.end_created_at);
      }
      if (this.orderForm.start_out_ware_day) {
        params.start_out_ware_day = changeDateString(
          this.orderForm.start_out_ware_day
        ).replace("00:00:00", "");
      }
      if (this.orderForm.end_out_ware_day) {
        params.end_out_ware_day = changeDateString(
          this.orderForm.end_out_ware_day
        ).replace("00:00:00", "");
      }
      if (this.statusActive === 5) {
        params.status = "-1";
      } else {
        params.status = "1";
      }
      await exporOrdertData(params);
      // let wb = XLSX.utils.table_to_book(document.querySelector('#out-table'))
      // for (let i in wb.Sheets.Sheet1) {
      //   if (i.indexOf('B') !== -1) {
      //     wb.Sheets.Sheet1[i].z = 'yyyy/m/d h:mm:ss'
      //   } else if (i.indexOf('C') !== -1 && i.indexOf('1') === -1) {
      //     wb.Sheets.Sheet1[i].v = parseInt(wb.Sheets.Sheet1[i].v)
      //   } else if (i.indexOf('D') !== -1) {
      //     wb.Sheets.Sheet1[i].z = '0'
      //   }
      // }
      // let wbout = XLSX.write(wb, {
      //   bookType: 'xlsx',
      //   bookSST: true,
      //   type: 'array'
      // })
      // try {
      //   let fileName = currentTime() + '.xlsx'
      //   FileSaver.saveAs(
      //     new Blob([wbout], {
      //       type: 'application/octet-stream'
      //     }),
      //     fileName
      //   )
      // } catch (e) {
      //   if (typeof console !== 'undefined') console.log(e, wbout)
      // }
      // return wbout
    },
    // 每日备货清单
    printStockList() {
      // if (this.ifSelectData()) {
      // this.$router.push({path: '/order/storeList', query: {id: this.selectOrderDataId}})
      // }
      this.$router.push("/bigorder/dayStockList");
    },
    // 打印出库清单
    printOutwareList() {
      // if (this.ifSelectData()) {
      this.$router.push("/bigorder/shippingList");
      // }
    },
    getTableStatus(index, isReturnBack) {
      if (!isReturnBack) {
        this.currentPage = 1;
        sessionStorage.setItem("bigorder_tab_index_pageIndex", 1);
      }
      this.statusActive = index;
      sessionStorage.setItem("bigorder_tab_index", index);
      this.orderDetailTableData = [];
      this.pagesize = 10;
      switch (index) {
        case 1:
          this.orderForm.instatus = "1";
          break;
        case 2:
          this.orderForm.instatus = "2";
          break;
        case 3:
          this.orderForm.instatus = "3,4";
          break;
        case 4:
          this.orderForm.instatus = "5,6";
          break;
        case 5:
          this.orderForm.instatus = "-1";
          break;
      }
      this.getOrderList();

      //物流轨迹 清除已选中的数据
      this.current_row_id = undefined;
      this.current_row_main_number = undefined;
    },
    // 获取选择的订单 勾选
    getSelectOrderData(val) {
      this.showdeliverySheet = false;
      this.selectOrderData = val;
      if (this.statusActive === 1 && val.length !== 0) {
        let listId = [];
        let listNo = [];
        val.forEach((n, i) => {
          listId.push(n.id);
          listNo.push(n.main_number);
        });
        this.selectOrderDataId = listId.join(",");
        this.selectOrderNo = listNo.join(",");
      } else if (val.length !== 0) {
        this.selectOrderDataId = val[0].id;
        this.selectOrderNo = val[0].main_number;
      }
    },
    // 勾选数据
    ifSelectData() {
      if (!this.selectOrderData || this.selectOrderData.length === 0) {
        this.$message.warning("请勾选列表");
        return false;
      } else {
        return true;
      }
    },
    // 接单
    acceptGoods() {
      if (this.ifSelectData()) {
        this.orderDetailTableData = [];
        this.$refs.orderTable.acceptGoods(this.selectOrderDataId);
      }
    },
    // 接单成功进入备货中  不跳转
    acceptGoodsOk() { },
    // 订单打包
    completeGoods() {
      if (this.ifSelectData()) {
        if (this.selectOrderData.length > 1) {
          this.$message.warning("只能选择一个");
        } else {
          localStorage.setItem(
            "bigorderData",
            JSON.stringify(this.selectOrderData)
          );
          this.$router.push({
            path: "/bigorder/completeStock",
            query: { id: this.selectOrderDataId }
          });
        }
        // this.$refs.orderTable.completeGoods(this.selectOrderDataId)
      }
    },
    // 已备货页签 编辑订单
    editOrderHandler(id) {
      // if (this.ifSelectData()) {
      localStorage.setItem(
        "bigorderData",
        JSON.stringify(this.selectOrderData)
      );
      if (this.statusActive === 3) {
        // 已备货且为直发可以通知物流取货
        this.$router.push({
          path: "/bigorder/completeStock",
          query: { id: id, showLogisticsSheet: "true" }
        });
      } else {
        this.$router.push({
          path: "/bigorder/completeStock",
          query: { id: id }
        });
      }
      // this.$refs.orderTable.completeGoods(this.selectOrderDataId)
      // }
    },
    // 取消备货
    cancelGoods() {
      if (this.ifSelectData()) {
        if (this.selectOrderData.length > 1) {
          this.$message.warning("只能勾选一个");
        } else {
          this.$refs.cancelPareDialog.cancelPareVisible = true;
          this.$refs.cancelPareDialog.orderNoGroups = this.selectOrderNo;
        }
      }
    },
    cancelOrder() {
      this.$refs.orderTable.cancelGoods(this.selectOrderDataId);
    },
    // 出库 工厂
    async factoryOutGoods(val) {
      // 不需要扫描
      if (this.selectOrderData.length >= 1) {
        // 订单取消提醒弹窗
        if (val === "dialogCancel") {
          cancelOrderData({
            ids: this.selectOrderData
              .map(item => {
                return item.id;
              })
              .join(",")
          }).then(res => {
            if (res.code === 200) {
              if (res.data.detail_count < 1) {
                this.factoryOutGoods("confirm");
              } else {
                this.cancelDialogTable = res.data;
                this.cancelOrderDialog = true;
              }
            }
          });
          return;
        }
        // 确认提醒弹窗
        if (val === "confirm") {
          this.outGoodsDialog = true;
          return;
        }
        // 出库
        if (val === "sureOut") {
          let arr = [];
          this.selectOrderData.forEach(item => {
            arr.push(item.id);
          });
          let params = {
            ids: arr.join(",")
          };
          let data = await bigorderOutWare(params);
          if (data.data.length === 0) {
            this.$message.success("备货出库成功");
            this.getOrderList();
          }
          if (data.data.length > 0) {
            data.data.forEach(item => {

              item.main_number = this.orderTableData.find(order => {
                return order.id == item.id;
              }).main_number;
            });
            let html = "";
            data.data.forEach(item => {
              html +=
                '<p style="padding:5px;">主订单号：' +
                item.main_number +
                "," +
                item.msg +
                "</p>";
            });
            this.$message({
              showClose: true,
              type: "error",
              iconClass: "11",
              dangerouslyUseHTMLString: true,
              message: html,
              duration: 0
            });
            this.getOrderList();
          }
          this.outGoodsDialog = false;
          this.cancelOrderDialog = false;
        }
      } else {
        this.$message.warning("请勾选列表");
      }
      // if (localStorage.getItem('need_scan') === '0') {
      // } else {
      //   this.$router.push('/bigorder/scanningStock')
      // }
    },
    // 获取单条订单详情
    async getDetailTable(row) {
      let params;
      let data;
      if (this.statusActive === 5) {
        params = {
          id: row.mo_id
        };
        data = await getWrongOrder(params);
      } else {
        params = {
          id: row.id
        };
        data = await getOrderDetail(params);
      }
      for (let i of data) {
        i.mo_statusName = getOdStatusList().statusList.filter(
          item => item.value === i.status
        )[0].label;
      }
      this.orderDetailTableData = data;
    },
    // 获取单条订单号（为了获取订单物流轨迹）2022-10-17
    getTrackNo(row) {
      this.current_row_id = row.id;
      this.current_row_main_number = row.main_number;
    },
    async getBoxData(row) {
      let params = { id: row.id };
      let data = await listBox(params);
      this.boxData = data;
      if (data) {
        for (let i of data) {
          i.status = row.od_statusName;
          // if (i.status === '2') {
          // } else if (i.status === '1') {
          //   i.status = '未到分仓'
          // }
        }
        this.$refs.orderDialog.boxDialogVisible = true;
        this.$refs.orderDialog.orderNo = `主订单号：${row.main_number}`;
      }
    },
    // 打印箱码
    async print(val) {
      if (this.ifSelectData()) {
        if (!val) {
          this.printDialogVisible = true;
          let boxNumTotal = [];
          this.selectOrderData.forEach(item => {
            if (item.box_num) {
              boxNumTotal.push(item.box_num);
            }
          });
          this.printBoxNumTotal = boxNumTotal
            .reduce((pre, curr) => {
              return Number(pre) + Number(curr);
            }, 0)
            .toFixed(0);
        } else {
          // this.$refs.orderTable.print(this.selectOrderData)
          let boxcodeList = [...this.selectOrderData];
          let ids = [];
          let failedData = [];
          boxcodeList.forEach(item => {
            ids.push(item.id);
          });
          let params = {
            ids: JSON.stringify(ids)
          };
          let res = await batchPrintBoxCode(params);
          if (res.code === 200) {
            let success = res.data.succeed;
            failedData = res.data.failed;
            if (failedData.length > 0) {
              failedData.forEach(item => {
                item.main_number = boxcodeList.find(order => {
                  return order.id === item.id;
                }).main_number;
              });
              let html = "";
              failedData.forEach(item => {
                html +=
                  '<p style="padding:5px;">主订单号：' +
                  item.main_number +
                  "," +
                  item.msg +
                  "</p>";
              });
              this.$message({
                showClose: true,
                type: "error",
                iconClass: "11",
                dangerouslyUseHTMLString: true,
                message: html,
                duration: 0
              });
            } else {
              let printData = [];
              for (const key in success) {
                if (success.hasOwnProperty(key)) {
                  let item = success[key];
                  for (let i of item) {
                    i.code = i.serial_number;
                    i.print_interval = 5;

                    printData.push(i);
                  }
                }
              }
              this.$refs.boxcode.myPrint(printData);
              this.printDialogVisible = false;
            }
          }
        }
      }
    },

    // 搜索
    searchOrderList() {
      this.currentPage = 1;
      this.getOrderList();
    },
    // 平台获取订单列表
    async getCommonOrderList() {
      const shipStatus = this.orderForm.shipping_status;
      this.loadOrderTable = true;
      let params = {
        main_number: this.orderForm.main_number,
        order_number: this.orderForm.order_number,
        instatus: this.orderForm.instatus,
        serial_number: this.orderForm.serialNumber,
        order_type: 1,
        is_qp: this.orderForm.is_qp,
        mo_status: this.orderForm.mainOrderStatus,
        sync_status: this.orderForm.syncStatus,
        shipping_delay_status:
          shipStatus && shipStatus.length ? shipStatus.join(",") : undefined,
        courier_number: this.orderForm.courierNumber,
        page: this.currentPage,
        page_size: this.pagesize
      };
      //推送日期
      if (this.orderForm.start_created_at) {
        params.start_created_at = changeDateString(
          this.orderForm.start_created_at
        );
      }
      if (this.orderForm.end_created_at) {
        params.end_created_at = changeDateString(this.orderForm.end_created_at);
      }
      // 要求发货日
      if (this.orderForm.start_out_ware_day) {
        params.start_out_ware_day = changeDateString(
          this.orderForm.start_out_ware_day
        ).replace("00:00:00", "");
      }
      if (this.orderForm.end_out_ware_day) {
        params.end_out_ware_day = changeDateString(
          this.orderForm.end_out_ware_day
        ).replace("00:00:00", "");
      }
      if (typeof this.orderForm.isBoxnum === "number") {
        params.is_boxnum = this.orderForm.isBoxnum;
      }
      if (this.statusActive === 4 || this.statusActive === 3) {
        params.courier_mobile = this.orderForm.courier_mobile;
      }
      // let data = await getFactoryOrderList(params);
      let data = await getNewList(params);
      let list = data.list || [];
      if (this.statusActive === 4) {
        list.forEach(item => {
          item.ts_status = "";
        });
      }
      this.orderTableData = list;
      this.totalCount = data.total;
      // 设置单据状态
      for (let i of this.orderTableData) {
        i.od_statusName = i.mo_status_str;
        i.async_create_statusName = i.sync_status_str; // 同步状态

        i.box_status_msg = i.box_status.msg; // 物流状态
        i.mobile = i.user_mobile; //客户电话
        i.address = i.user_address; //客户地址
        i.express = i.courier_name; //快递名称
      }
      this.loadOrderTable = false;
    },
    // 工厂|直发获取订单列表
    async getNewOrderData() {
      this.loadOrderTable = true;
      const {
        main_number,
        order_number,
        instatus,
        serialNumber,
        courierNumber,
        mainOrderStatus,
        syncStatus,
        box_status,
        start_created_at,
        end_created_at,
        start_out_ware_day,
        end_out_ware_day,
        isBoxnum,
        courier_mobile,
        shipping_status
      } = this.orderForm;

      let params = {
        main_number, //主订单号
        order_number, //子订单号
        instatus, //
        serial_number: serialNumber, //编号
        courier_number: courierNumber, //快递单号
        order_type: 1, //大单
        mo_status: mainOrderStatus, //主单状态
        sync_status: syncStatus, //同步状态
        shipping_delay_status:
          shipping_status && shipping_status.length
            ? shipping_status.join(",")
            : undefined,
        page: this.currentPage,
        page_size: this.pagesize
      };

      if (this.statusActive == 4) {
        params.box_status = box_status; //物流状态（包裹状态）
      }
      if (start_created_at) {
        this.loadOrderTable = true;
        params.start_created_at = changeDateString(start_created_at);
      }
      if (end_created_at) {
        params.end_created_at = changeDateString(end_created_at);
      }
      if (start_out_ware_day) {
        params.start_out_ware_day = changeDateString(
          start_out_ware_day
        ).replace("00:00:00", "");
      }
      if (end_out_ware_day) {
        params.end_out_ware_day = changeDateString(end_out_ware_day).replace(
          "00:00:00",
          ""
        );
      }
      if (typeof isBoxnum === "number") {
        params.is_boxnum = isBoxnum;
      }
      if (this.statusActive === 4 || this.statusActive === 3) {
        params.courier_mobile = courier_mobile;
      }
      let data = await getNewList(params);
      let list = data.list || [];
      this.orderTableData = list;
      this.totalCount = data.total;
      for (let i of this.orderTableData) {
        i.od_statusName = i.mo_status_str;
        i.async_create_statusName = i.sync_status_str; // 同步状态

        i.box_status_msg = i.box_status.msg; // 物流状态
        i.mobile = i.user_mobile; //客户电话
        i.address = i.user_address; //客户地址
        i.express = i.courier_name; //快递名称
      }

      this.loadOrderTable = false;
    },
    // 获取失效订单
    async getListWrongDetail(isReturnBack) {
      this.loadOrderTable = true;
      let params = {
        main_number: this.orderForm.main_number,
        order_number: this.orderForm.order_number,
        instatus: this.orderForm.instatus,
        page: this.currentPage,
        pagesize: this.pagesize,
        serial_number: this.orderForm.serialNumber,
        courier_number: this.orderForm.courierNumber,
        order_type: 1
      };
      if (this.orderForm.start_created_at) {
        params.start_created_at = changeDateString(
          this.orderForm.start_created_at
        );
      }
      if (this.orderForm.end_created_at) {
        params.end_created_at = changeDateString(this.orderForm.end_created_at);
      }
      if (this.orderForm.start_out_ware_day) {
        params.start_out_ware_day = changeDateString(
          this.orderForm.start_out_ware_day
        ).replace("00:00:00", "");
      }
      if (this.orderForm.end_out_ware_day) {
        params.end_out_ware_day = changeDateString(
          this.orderForm.end_out_ware_day
        ).replace("00:00:00", "");
      }
      if (typeof this.orderForm.isBoxnum === "number") {
        params.is_boxnum = this.orderForm.isBoxnum;
      }
      let data = await getListWrongDetail(params);
      data.list.forEach(item => {
        item.total_amount = item.amount; // 订购总量
        item.total_send_amount = ""; // total_send_amount
        // item.total_send_amount = item.send_amount // total_send_amount
        if (item.price) {
          if (item.amount) {
            // 订单总金额
            item.total_price = (item.amount * item.price).toFixed(2);
          }
          if (item.send_amount) {
            // 实发总金额
            // item.total_send_price = (item.send_amount * item.price).toFixed(2)
            item.total_send_price = "";
          }
        }
      });
      this.statusActive = 5;
      this.orderTableData = data.list;
      for (let i of this.orderTableData) {
        i.od_statusName = getOdStatusList().mo_statusList.filter(item => {
          return item.value === i.status;
        })[0].label;
      }
      this.totalCount = data.total;
      this.loadOrderTable = false;
    },
    // isReturnBack 是否从其他位置返回该页面
    async getOrderList(isReturnBack) {
      if (this.statusActive !== 5) {
        if (
          localStorage.getItem("shop_type") === "1" ||
          localStorage.getItem("shop_type") === "2"
        ) {
          //工厂|直发 2022-10-17
          this.getNewOrderData();
        } else {
          this.getCommonOrderList();
        }
      }
      if (this.statusActive === 5) {
        this.getListWrongDetail(isReturnBack);
      }
    },
    serachOrder() { },
    // 每页条数改变
    handleSizeChange(val) {
      this.pagesize = val;
      this.getOrderList();
    },
    // 页码改变
    handleCurrentChange(val) {
      sessionStorage.setItem("bigorder_tab_index_pageIndex", val);
      this.currentPage = val;
      this.getOrderList();
    },
    // 备货完成
    autoPareDoneHandler() {
      if (this.selectOrderData.length > 0) {
        let arr = [];
        this.selectOrderData.forEach(item => {
          arr.push(item.id);
        });
        autoPareDone({ ids: arr.join(",") }).then(res => {
          if (res.code === 200) {
            this.getOrderList();
          }
        });
      } else {
        this.$message.warning("请勾选列表");
      }
    },
    // 导出货物清单
    exportGoodsListHandler() {
      if (this.ifSelectData()) {
        this.showdeliverySheet = true;
        this.$nextTick(function () {
          this.$refs.deliverySheet.print();
        });
        console.log(this.selectOrderData, "selectOrderDataId");
        // if (this.selectOrderData.length > 1) {
        //   this.$message.warning('只能选择一个')
        // } else {
        //   this.showdeliverySheet = true
        //   this.$nextTick(function () {
        //     this.$refs.deliverySheet.print()
        //   })
        // }
      }
    },
    // 通知物流取货
    async logisticsGetGoods(next) {
      if (this.ifSelectData()) {
        if (!next) {
          cancelOrderData({
            ids: this.selectOrderData
              .map(item => {
                return item.id;
              })
              .join(",")
          }).then(res => {
            if (res.code === 200) {
              if (res.data.detail_count < 1) {
                this.logisticsGetGoods(true);
              } else {
                this.cancelDialogTable = res.data;
                this.cancelOrderDialog = true;
              }
            }
          });
        } else {
          let arr = [];
          this.selectOrderData.forEach(item => {
            arr.push(item.id);
          });
          let params = {
            ids: arr.join(",")
          };
          let res = await printLogisticsSheet(params);
          if (res.code === 200) {
            let data = res.data;
            if (data.length === 0) {
              this.$message.warning(
                "已发送请求，通知物流结果在2-3分钟后返回,可刷新页面查看"
              );
              this.getOrderList();
            } else {
              let htmlStr =
                '<p style="padding:5px;color:red;">通知物流结果在2-3分钟后返回,可刷新页面查看</p>';
              this.orderTableData.forEach(item => {
                data.forEach(erritem => {
                  if (item.id === erritem.id) {
                    htmlStr += `<p style="padding:5px;color:#000;">${item.main_number}:${erritem.msg}</p>`;
                  }
                });
              });
              this.$message({
                dangerouslyUseHTMLString: true,
                duration: 5000,
                message: htmlStr,
                type: "error",
                showClose: true
              });
              this.getOrderList();
            }
          } else {
            this.$message.error(res.message);
          }
        }
      }
    },
    // 取消订单提醒弹窗
    cancelDialogHandler() {
      this.cancelOrderDialog = false;
    },
    // 确认订单出库提醒
    cancelDialogConfirmHandler() {
      this.factoryOutGoods("confirm");
    },
    // 打印采购订单
    prinPurchaseHandler() {
      this.$router.push("/bigorder/prinPurchase");
      // getPurchaseList({
      //   is_purchase: 0
      // })
    },
    // 查看子单号
    getTransportDetail(row) {
      this.showTransportDetailDialog = true;
      this.TransportDetailDialogRow = row;
    },
    // 查看同步状态信息
    getDetailAsyncStatus(row) {
      //console.log(row.main_number, row.async_create_time)
      this.orderSyncDialogVisible = true;
      this.orderSyncInfo = {
        main_number: row.main_number,
        async_create_time: row.async_create_time
      };
    },
    // 快速设置打包
    quickSetBoxNum() {
      if (this.ifSelectData()) {
        this.$router.push({
          path: "/bigorder/QuickSetBoxNum",
          query: {
            params: this.selectOrderData
          }
        });
      }
    },
    // 录入物流运单
    handleCommand(val) {
      if (val === "b") {
        this.inputTsHandler("all");
      }
      if (val === "a") {
        this.inputTsHandler();
      }
    },
    // 录入物流运单
    inputTsHandler(status) {
      if (status === "all") {
        this.$router.push({
          name: "biginputTS",
          params: {
            ids: "",
            orderType: this.orderForm.instatus,
            isAll: "YES"
          }
        });
      } else {
        if (this.selectOrderData.length > 0) {
          let arr = [];
          this.selectOrderData.forEach(item => {
            arr.push(item.id);
          });
          this.$router.push({
            name: "biginputTS",
            params: {
              ids: JSON.stringify(arr.join(",")),
              orderType: this.orderForm.instatus,
              isAll: "NO"
            }
          });
        } else {
          this.$message.warning("请选择订单");
        }
      }
    }
  }
};
</script>
<style lang="scss">
.order {
  .el-form .el-form-item__label {
    width: 65px;
    white-space: nowrap;
  }

  .el-button.blue {
    color: #409eff;
    background-color: #409eff;
    border-color: #409eff;
    color: #fff;
  }

  .tableTitle {
    margin-bottom: 2px;
    margin-top: 10px;
    padding-top: 5px;
    border-top: 1px solid #ddd;

    span {
      font-size: 12px;
    }

    span:not(:first-child) {
      color: red;
    }

    .tableStatus {
      display: flex;
      justify-content: space-between;

      div {
        display: flex;
      }

      .status {
        cursor: pointer;
        height: 30px;
        width: 80px;
        margin-right: 1px;
        margin-top: 5px;
        border-radius: 8px 8px 0px 0px;
        background-color: rgb(115, 129, 140);

        p {
          color: #fff;
          font-size: 14px;
          width: 100%;
          text-align: center;
          line-height: 4px;
        }
      }

      .status.active,
      .status:hover {
        background-color: rgb(164, 180, 193);
      }
    }

    p {
      line-height: 10px;
    }

    .btns {
      margin-top: 5px;

      .editBtn {
        background-color: #409eff;
        border-color: #409eff;
      }
    }
  }

  .goodsInfo {
    border-top: 1px solid #ddd;
  }
}

.red-color-text {
  color: red;
  font-size: 20px;
  font-weight: bold;
  display: inline-block;
  padding: 0 5px;
}

.notice {
  color: #409eff;
  cursor: pointer;
}

.serch-wrap {
  position: relative;
  padding-right: 50px;
}

.drop-down-wrap {
  position: absolute;
  right: 20px;
  top: 5px;
}
</style>



// WEBPACK FOOTER //
// src/pages/bigorder/order.vue